import styled from 'styled-components';
import {
  GRAPHITE_COLOR,
  ICE_COLOR,
  LG_COLOR,
  MAIN_BLUE_COLOR,
  SOFT_GREY_COLOR,
} from 'containers/App/constants';

export const RemoteLayoutStyles = styled.div`
  background: ${ICE_COLOR};
  min-height: 100%;
  padding: 24px;

  .remote-layout-shell {
    margin: 0 auto;
    max-width: 1400px;
  }

  .remote-layout-header,
  .remote-layout-panel {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
  }

  .remote-layout-header {
    align-items: flex-start;
    display: flex;
    gap: 18px;
    justify-content: space-between;
    margin-bottom: 18px;
    padding: 22px 24px;
  }

  .remote-layout-eyebrow {
    color: ${LG_COLOR};
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .remote-layout-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.65rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
  }

  .remote-layout-subtitle {
    color: #66707d;
    margin: 8px 0 0;
    max-width: 760px;
  }

  .remote-layout-metric {
    border-left: 1px solid #dde2e8;
    min-width: 160px;
    padding-left: 24px;
  }

  .remote-layout-metric-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .remote-layout-metric-value {
    color: ${MAIN_BLUE_COLOR};
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
  }

  .remote-layout-panel {
    overflow: hidden;
  }

  .remote-layout-panel-header {
    align-items: center;
    background: ${SOFT_GREY_COLOR};
    border-bottom: 1px solid #d9dde3;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 14px 18px;
  }

  .remote-layout-panel-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
  }

  .remote-layout-panel-subtitle {
    color: #66707d;
    font-size: 0.86rem;
    margin: 4px 0 0;
  }

  .remote-layout-add-button:hover,
  .remote-layout-add-button:active,
  .remote-layout-add-button:active:focus {
    background-color: #8d012d !important;
    border-color: #8d012d !important;
    color: #fff !important;
  }

  .remote-layout-alert {
    margin: 18px 18px 0;
  }

  .remote-layout-empty-state {
    align-items: center;
    color: #66707d;
    display: flex;
    justify-content: center;
    min-height: 260px;
    margin: 18px;
    border: 1px dashed #cfd6df;
    border-radius: 8px;
    background: #fcfdff;
  }

  .remote-layout-table {
    max-height: calc(100vh - 310px);
    min-height: 360px;
    overflow: auto;
    padding: 0;
    text-align: left;

    &::before {
      border-radius: 0;
      color: ${GRAPHITE_COLOR};
      font-size: 1rem;
    }

    table {
      border: 0;
      min-width: 980px;
    }

    tr {
      display: flex;
    }

    thead {
      position: sticky;
      top: 0;
      z-index: 2;
    }

    th {
      align-items: stretch;
      background: #f3f5f8;
      border-bottom: 1px solid #d9dde3;
      border-right: 0;
      color: ${GRAPHITE_COLOR};
      font-size: 0.78rem;
      font-weight: 700;
      justify-content: flex-start;
      padding: 12px;
      text-transform: uppercase;
    }

    td {
      border-bottom: 1px solid #e3e7ec;
      border-right: 0;
      color: ${GRAPHITE_COLOR};
      padding: 12px;
    }

    tbody tr:nth-child(even) {
      background: #f8f9fb;
    }

    tbody tr:hover {
      background: #fff5f8;
    }

    .id {
      width: 7%;
    }
    .name {
      width: 28%;
    }
    .created {
      width: 25%;
    }
    .modified {
      width: 25%;
    }
    .actions {
      width: 15%;
    }

    .data.name,
    .data.id {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .data.actions {
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 8px;
    }

    .rs-btn-icon.rs-btn-circle {
      align-items: center;
      background: #fff;
      border: 1px solid #dde2e8;
      color: ${GRAPHITE_COLOR};
      display: inline-flex;
      height: 34px;
      justify-content: center;
      width: 34px;
    }

    .rs-btn-icon.rs-btn-circle:hover {
      border-color: ${LG_COLOR};
      color: ${LG_COLOR};
    }

    .column-filter input {
      border: 1px solid #cfd6df;
      border-radius: 6px;
      min-height: 32px;
      padding: 6px 8px;
      width: 100%;
    }

    .pagination {
      align-items: center;
      background: #fff;
      border: 0;
      border-top: 1px solid #d9dde3;
      gap: 8px;
      justify-content: flex-end;
      padding: 8px 12px;
    }

    .pagination input,
    .pagination select {
      border: 1px solid #cfd6df;
      border-radius: 6px;
      min-height: 32px;
      padding: 4px 8px;
    }
  }

  @media (max-width: 991px) {
    padding: 16px;

    .remote-layout-header {
      flex-direction: column;
      padding: 18px;
    }

    .remote-layout-metric {
      border-left: 0;
      border-top: 1px solid #dde2e8;
      min-width: 0;
      padding-left: 0;
      padding-top: 16px;
      width: 100%;
    }

    .remote-layout-panel-header {
      align-items: flex-start;
      flex-direction: column;
    }
  }
`;
